<template>
    <div>
        ヘッダーだよ
    </div>
</template>

<script>
export default {
    name: 'PageHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/PageHeader.vue